import {LeagueCompetitorStanding} from "./league-competitor-standing";
import {MultiLangField} from "../multi-lang-field";
import {LeagueStandingsViewMode} from "./league-standings-view-mode";

export class LeagueStandingsMeta {
    appliedAt?: Date;
    raceType?: LeagueRaceType;
    calculatedAt?: Date;
    racesApplied?: LeagueStandingsRace[];
    metaType?: LeagueStandingsViewMode;
}


export class LeagueStandingsResult {
    standings?: LeagueCompetitorStanding[];
    raceType?: LeagueRaceType;
}

export enum LeagueRaceType {
    INDIVIDUAL= 1,
    TEAM = 2
}

export class LeagueStandingsRace {
    raceId?: number;
    eventId?: number;
    raceName?: MultiLangField;
    eventName?: MultiLangField;
    round?: number;
    isTeam?: boolean;
    isBonus?: boolean;
    hasRoundResults?: boolean;
    raceStart?: Date;
    eventStart?: Date;
}

export class LeaguePoints {
    absoluteRank?:number;
    genderRank?:number;
    categoryRank?:number;
    totalPoints?:number;
    basePoints?:number;
    bonus?:number;
    penalty?:number;
}
